import React from 'react';

import { IonButtons, IonToolbar } from '@ionic/react';

import ColumnsPicker from './components/ColumnsPicker';
import DimensionSelect from './components/DimensionSelect';
import './index.css';

const DataTableToolbar = () => {
  return (
    <IonToolbar className={'datatable-toolbar'}>
      <IonButtons slot={'start'}>
        <DimensionSelect />
      </IonButtons>
      <IonButtons slot={'end'}>
        <ColumnsPicker />
      </IonButtons>
    </IonToolbar>
  );
};
export default DataTableToolbar;
